"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

var _NotificationsProvider = require("../../providers/NotificationsProvider");

function useNotifications() {
  var context = (0, _react.useContext)(_NotificationsProvider.NotificationsContext);
  return (0, _react.useMemo)(function () {
    return context;
  }, [context]);
}

var _default = useNotifications;
exports.default = _default;